import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { TestNavigationRootPage } from 'pages/test-navigation-root/test-navigation-root';

@NgModule({
    declarations: [TestNavigationRootPage],
    imports: [PagesModule, ComponentsModule]
})
export class TestNavigationRootPageModule {}
